module.exports = __webpack_public_path__ + "img/root01.e786f1a5.png";